import React from 'react';
import { Link } from 'react-router-dom';
import './Partner.css';
import logo from '../Assets/images/logo.jpg';

const Partner = () => {
  return (
    <div className="partner-page">
    
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - Bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Our Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </nav>
          <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
        </div>
      </header>

      <section className="partner-hero">
        <h1>Partner With Limoxy World</h1>
        <p>Join our global network of luxury chauffeur professionals and affiliates.</p>
      </section>

      <section className="partner-benefits">
        <h2>Why Become a Partner?</h2>
        <div className="benefit-boxes">
          <div className="benefit">
            <h3>🌍 Global Reach</h3>
            <p>Connect with clients in over 45,000 cities across the world.</p>
          </div>
          <div className="benefit">
            <h3>💎 Premium Brand</h3>
            <p>Deliver services under a luxury name trusted by top-tier clients.</p>
          </div>
          <div className="benefit">
            <h3>🚘 Business Growth</h3>
            <p>Increase your bookings and exposure with our trusted platform.</p>
          </div>
        </div>
      </section>

     

     
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>Luxury chauffeur services across 45,000+ global locations. Precision. Trust. Class.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Partner;